import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactInfo = () => {
  const contactMethods = [
    {
      icon: 'Mail',
      title: 'Correo Electrónico',
      value: 'contacto@orbiax.co',
      description: 'Respuesta en 24 horas',
      action: () => window.open('mailto:contacto@orbiax.co')
    },
    {
      icon: 'Phone',
      title: 'Teléfono',
      value: '+57 3228571202',
      description: 'Lun - Vie, 9:00 AM - 6:00 PM',
      action: () => window.open('tel:+573228571202')
    },
    {
      icon: 'MessageCircle',
      title: 'WhatsApp',
      value: '+573228571202',
      description: 'Respuesta inmediata',
      action: () => window.open('https://wa.me/+573228571202')
    },
    {
      icon: 'MapPin',
      title: 'Oficina Principal',
      value: 'Av calle 45 - 36-70',
      description: 'Bogotá, Colombia',
      //action: () => window.open('pendientela ubi')
    }
  ];

  const businessHours = [
    { day: 'Lunes - Viernes', hours: '9:00 AM - 6:00 PM' },
  ];

  const socialLinks = [
    {
      name: 'LinkedIn',
      icon: 'Linkedin',
      url: 'https://linkedin.com/company/orbiax',
      color: 'hover:text-blue-400'
    },
  
    {
      name: 'Twitter',
      icon: 'Twitter',
      url: 'https://twitter.com/orbiax',
      color: 'hover:text-blue-400'
    }
  ];

  const responseMetrics = [
    {
      metric: '< 24h',
      label: 'Tiempo de Respuesta',
      icon: 'Clock'
    },
    {
      metric: '98%',
      label: 'Satisfacción Cliente',
      icon: 'Star'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Contact Methods */}
      <div className="bg-white rounded-2xl p-8 border border-black/10">
        <h2 className="text-2xl sm:text-[26px] font-medium text-black mb-6" style={{ letterSpacing: '-0.005em' }}>
          Información de Contacto
        </h2>

        <div className="space-y-2">
          {contactMethods.map((method, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 p-4 rounded-lg hover:bg-black/[0.03] transition-colors cursor-pointer group"
              onClick={method.action}
            >
              <div className="w-12 h-12 rounded-lg bg-black flex items-center justify-center shrink-0">
                <Icon name={method.icon} size={22} color="white" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-black group-hover:text-[#7C3AED] transition-colors">
                  {method.title}
                </h3>
                <p className="text-black/70 font-medium">{method.value}</p>
                <p className="text-sm text-black/50">{method.description}</p>
              </div>
              <Icon name="ExternalLink" size={16} className="text-black/30 group-hover:text-[#7C3AED] transition-colors" />
            </div>
          ))}
        </div>
      </div>

      {/* Business Hours */}
      <div className="bg-white rounded-2xl p-8 border border-black/10">
        <h3 className="text-lg font-semibold text-black mb-6">
          Horarios de Atención
        </h3>

        <div className="space-y-4">
          {businessHours.map((schedule, index) => (
            <div key={index} className="flex justify-between items-center py-2">
              <span className="text-black font-medium">{schedule.day}</span>
              <span className="text-black/60">{schedule.hours}</span>
            </div>
          ))}
        </div>

        <div className="mt-6 p-4 bg-[#7C3AED]/5 rounded-lg border border-[#7C3AED]/15">
          <div className="flex items-center space-x-2">
            <Icon name="Info" size={16} className="text-[#7C3AED]" />
            <span className="text-sm font-semibold text-black">Consultas de Emergencia</span>
          </div>
          <p className="text-sm text-black/60 mt-1">
            Para consultas urgentes fuera del horario, contáctanos por WhatsApp.
          </p>
        </div>
      </div>

      {/* ===== SECCIÓN DE OFICINA COMENTADA ===== */}
      {/*
      <div className="bg-card rounded-2xl p-8 border border-border">
        <h3 className="text-xl font-bold text-foreground mb-6">
          Nuestra Oficina
        </h3>
        
        <div className="aspect-video rounded-lg overflow-hidden mb-6">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title="Orbiax Office Location"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=37.7749,-122.4194&z=14&output=embed"
            className="border-0"
          />
        </div>
        
        <div className="flex items-start space-x-4">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="MapPin" size={20} className="text-primary" />
          </div>
          <div>
            <h4 className="font-semibold text-foreground">Oficina Principal</h4>
            <p className="text-muted-foreground">Av  calle 45 - 36-70</p>
            <p className="text-muted-foreground">Bogotá </p>
            <p className="text-muted-foreground">Colombia</p>
          </div>
        </div>

        <Button
          variant="outline"
          className="w-full mt-6"
          iconName="Navigation"
          iconPosition="left"
          onClick={() => window.open('https://maps.google.com?q=37.7749,-122.4194')}
        >
          Ver Direcciones
        </Button>
      </div>
      */}

      {/* Response Metrics */}
      <div className="bg-white rounded-2xl p-8 border border-black/10">
        <h3 className="text-lg font-semibold text-black mb-6">
          Nuestro Compromiso
        </h3>

        <div className="grid grid-cols-1 gap-6">
          {responseMetrics.map((item, index) => (
            <div key={index} className="flex items-center space-x-4">
              <div className="w-12 h-12 rounded-lg bg-black flex items-center justify-center">
                <Icon name={item.icon} size={22} color="white" />
              </div>
              <div>
                <div className="text-2xl font-semibold text-black">{item.metric}</div>
                <div className="text-sm font-medium text-black/50 uppercase tracking-wide">{item.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Social Media */}
      <div className="bg-white rounded-2xl p-8 border border-black/10">
        <h3 className="text-lg font-semibold text-black mb-6">
          Síguenos
        </h3>

        <div className="flex space-x-3">
          {socialLinks.map((social, index) => (
            <button
              key={index}
              onClick={() => window.open(social.url, '_blank')}
              className="w-11 h-11 rounded-full border border-black/15 text-black/60 flex items-center justify-center transition-colors hover:border-black/40 hover:text-black"
              title={social.name}
            >
              <Icon name={social.icon} size={18} />
            </button>
          ))}
        </div>

        <p className="text-sm text-black/60 mt-4">
          Mantente actualizado con las últimas noticias y actualizaciones de Orbiax.
        </p>
      </div>
    </div>
  );
};

export default ContactInfo;